export const OPT_IN_GROUP_VALUE = '2:1';
export const OPT_OUT_GROUP_VALUE = '2:0';
